import { render } from "./AddMarchandPage.vue?vue&type=template&id=24ab96f9&ts=true"
import script from "./AddMarchandPage.vue?vue&type=script&lang=ts"
export * from "./AddMarchandPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__